import NavbarComponent from "./components/common/NavbarComponent";
import AboutComponent from "./components/home/AboutComponent";
import ProductComponent from "./components/home/ProductComponent";
import TrendingPComponent from "./components/home/TrendingPComponent";
import TopComponent from "./components/home/TopComponent";
import ContactComponent from "./components/home/ContactComponent";
import Footer from "./components/home/Footer";

function App() {
  return (
    <>
      <NavbarComponent />
      <TopComponent />
      <AboutComponent />
      <ProductComponent />
      <TrendingPComponent />
      <ContactComponent />
      <Footer />
    </>
  );
}

export default App;
